@if (exportWindowOpen$ | async) {
<kendo-dialog [width]="1300">
    <div class="export-modal-content">
        <div>
            <h3>{{ title() }}</h3>
        </div>
        <div class="export-header">
            <p class="export-description">
                Export will be generated based upon selections below. If
                selections are modified, those new selections will not be
                reflected on the Dashboard.
            </p>
            <button class="clear-button" (click)="clearFilters()">
                <span class="clear-icon">✕</span> CLEAR ALL
            </button>
        </div>

        <section>
            <app-single-selection-entity [(ngModel)]="selectedEntity"
                                         (entityChanged)="onEntityChanged($event)" />
            <div class="control-row">
                <div class="col-3 width24">
                    <app-date-range-filter [formGroup]="dateRangeFormGroup"
                                           [labelText]="'Date Range'"
                                           [startDate]="startDate ?? null"
                                           [endDate]="endDate ?? null"
                                           style="
                                --float-label-color: #3d3d3d;
                                --k-textbox-border-bottom: solid 2px black;
                                width: 25%;
                            " />
                </div>
                <div class="col-3 width24"
                     *ngFor="let option of aggregationOptions">
                    <kendo-label [text]="option.label">
                        <kendo-combobox [data]="option.data"
                                        [(ngModel)]="option.selectedValue">
                        </kendo-combobox>
                    </kendo-label>
                </div>
            </div>

            <!-- Content projection for filters -->
            <ng-content></ng-content>
        </section>
    </div>

    <div class="dialog-actions">
        <button class="dialog-button cancel-button"
                (click)="closeExportWindow()">
            CANCEL
        </button>
        <button class="dialog-button export-button" (click)="exportData()">
            EXPORT
        </button>
    </div>
</kendo-dialog>
}
